@if (open) {
  <div class="fixed inset-0 z-50 flex">
    <button
      type="button"
      class="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
      (click)="closed.emit()"
      [attr.aria-label]="'nav.close' | translate"
    ></button>

    <aside
      class="relative z-10 mr-auto flex h-full w-[min(88vw,22rem)] flex-col overflow-hidden border-r border-[#ece4f3] bg-white text-[#3d2652] shadow-2xl"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'nav.menu' | translate"
    >
      <header
        class="relative overflow-hidden bg-gradient-to-br from-[#5a2f6b] via-[#6e3a82] to-[#8b4fa0] px-4 pb-5 pt-4 text-white"
      >
        <div
          class="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-white/10 blur-2xl"
          aria-hidden="true"
        ></div>
        <div
          class="pointer-events-none absolute -bottom-16 -left-10 h-32 w-32 rounded-full bg-white/5 blur-2xl"
          aria-hidden="true"
        ></div>

        <div class="relative flex items-center justify-between">
          @if (currentSection()) {
            <button
              type="button"
              class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white/15 text-white backdrop-blur-sm transition-colors hover:bg-white/25"
              (click)="goBackToMenus()"
              [attr.aria-label]="'common.back' | translate"
            >
              <span class="material-icons text-lg" aria-hidden="true">chevron_left</span>
            </button>
          } @else {
            <div
              class="inline-flex h-9 items-center gap-2 rounded-lg bg-white/95 px-2.5 shadow-sm"
            >
              <img
                src="assets/kiraah/logo-kiraah.svg"
                alt="Kiraah"
                class="h-5 w-auto"
                decoding="async"
              />
            </div>
          }

          <button
            type="button"
            class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white/15 text-white backdrop-blur-sm transition-colors hover:bg-white/25"
            (click)="closed.emit()"
            [attr.aria-label]="'nav.close' | translate"
          >
            <span class="material-icons text-base" aria-hidden="true">close</span>
          </button>
        </div>

        <div class="relative mt-4 flex items-center gap-3">
          <div
            class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/15 text-white ring-1 ring-white/25 backdrop-blur-sm"
          >
            @if (currentSection(); as section) {
              <span class="material-icons text-[22px]" aria-hidden="true">{{ section.Icon }}</span>
            } @else {
              <span class="material-icons text-[22px]" aria-hidden="true">apps</span>
            }
          </div>
          <div class="min-w-0 flex-1">
            @if (currentSection(); as section) {
              <p
                class="text-[0.62rem] font-semibold uppercase tracking-[0.14em] text-white/70"
              >
                {{ activeAppName || ("app.launcher.title" | translate) }}
              </p>
              <p class="mt-0.5 truncate text-[1.05rem] font-semibold leading-tight">
                {{ section.Label | translate }}
              </p>
            } @else {
              <p
                class="text-[0.62rem] font-semibold uppercase tracking-[0.14em] text-white/70"
              >
                {{ "nav.menu" | translate }}
              </p>
              <p class="mt-0.5 truncate text-[1.05rem] font-semibold leading-tight">
                {{ activeAppName || ("app.launcher.title" | translate) }}
              </p>
            }
          </div>
        </div>
      </header>

      <div class="flex-1 overflow-y-auto px-3 pb-6 pt-3">
        @if (sections.length === 0) {
          <p class="rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-3 py-3 text-sm text-[#7a6b8a]">
            {{ "app.launcher.empty" | translate }}
          </p>
        } @else if (currentSection() !== null) {
          <ul class="space-y-1" role="list">
            @for (item of currentSection()!.Items; track item.Uid) {
              <li>
                <button
                  type="button"
                  class="mobile-drawer__item flex w-full items-center gap-3 rounded-xl border border-transparent px-3 py-2.5 text-left text-sm transition-colors hover:bg-[#f5f0fa]"
                  [class.mobile-drawer__item--active]="item.IsDefaultHome"
                  (click)="itemSelected.emit(item.Route)"
                >
                  <span
                    class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#f5f0fa] text-[#5a2f6b]"
                  >
                    <span class="material-icons text-[18px]" aria-hidden="true">{{ item.Icon }}</span>
                  </span>
                  <span class="min-w-0 flex-1 truncate font-medium">
                    @if (item.Label.trim()) {
                      {{ item.Label }}
                    } @else {
                      {{ item.LabelKey | translate }}
                    }
                  </span>
                  @if (item.IsDefaultHome) {
                    <span
                      class="rounded-full border border-[#dccbe8] bg-[#efe6f6] px-2 py-0.5 text-[0.62rem] font-semibold uppercase tracking-[0.06em] text-[#5a2f6b]"
                    >
                      {{ "app.launcher.defaultBadge" | translate }}
                    </span>
                  }
                </button>
              </li>
            }
          </ul>
        } @else {
          <ul class="space-y-1.5" role="list">
            @for (menu of sections; track menu.Uid) {
              <li>
                <button
                  type="button"
                  class="mobile-drawer__menu flex w-full items-center gap-3 rounded-xl border border-[#ece4f3] bg-white px-3 py-3 text-left transition-colors hover:bg-[#faf7fc]"
                  (click)="openSection(menu.Uid)"
                >
                  <span
                    class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#efe6f6] text-[#5a2f6b]"
                  >
                    <span class="material-icons text-[20px]" aria-hidden="true">{{ menu.Icon }}</span>
                  </span>
                  <span class="min-w-0 flex-1">
                    <span class="block truncate text-sm font-semibold text-[#3d2652]">
                      @if (menu.Label.trim()) {
                        {{ menu.Label }}
                      } @else {
                        {{ menu.LabelKey | translate }}
                      }
                    </span>
                  </span>
                  @if (sectionShowsSubmenu(menu)) {
                    <span class="material-icons text-base text-[#7a6b8a]" aria-hidden="true">
                      chevron_right
                    </span>
                  }
                </button>
              </li>
            }
          </ul>
        }
      </div>

      <footer class="border-t border-[#ece4f3] px-3 py-3">
        <button
          type="button"
          class="flex w-full items-center justify-center gap-2 rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-3 py-3 text-sm font-semibold text-[#5a2f6b] transition-colors hover:bg-[#efe6f6]"
          (click)="backToApps.emit()"
        >
          <span class="material-icons text-base" aria-hidden="true">apps</span>
          {{ "nav.changeApp" | translate }}
        </button>
      </footer>
    </aside>
  </div>
}
